module.exports = __webpack_public_path__ + "img/arrow-circle-broken-left.6aae501e.svg";